export default {
  /* 系统公共配置 */
  systemSettingUrl: '/api/dictionary_query/logistics',
  /** 汇率 */
  rateList: '/api/currency/convert',
}
